import type React from 'react';
import { styled } from 'styled-components';

export const LeftTitle = styled.span`
  margin-right: 10px;
`;

export const RightTitle = styled.span`
  margin-left: 10px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 38px;
  margin: 0;
  cursor: pointer;
`;

export interface IGroup {
  leftTitle?: string;
  rightTitle?: string;
  children?: React.ReactNode;
}

const Group: React.FC<IGroup> = ({ leftTitle, rightTitle, children }) => (
  <Wrapper>
    {leftTitle && <LeftTitle>{leftTitle}</LeftTitle>}
    {children}
    {rightTitle && <RightTitle>{rightTitle}</RightTitle>}
  </Wrapper>
);

export default Group;
